import { AxiosError } from 'axios';
import { useState } from 'react';

// import toast from 'react-hot-toast';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useDriverDetails = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [driverDetailsData, setDriverDetailsData] = useState<any>(null);

    const onDriverDetailsError = (err: AxiosError<ErrorHttpResponse>) => {
        // toast.error(
        //     err?.response?.data?.message ??
        //     'Something went wrong while fetching driver details.',
        // );
    };

    const onDriverDetailsSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<DriverDetailsDataType>) => {
        // toast.success('Driver details fetched successfully.');
        setDriverDetailsData(data);
    };

    const getDriverDetails = (driverId: string) => {
        const url: HttpConfig = {
            url: `api/v1/dispatchers/${driverId}/employment-details`,
            method: 'get',

        };
        request(url, onDriverDetailsSuccess, setLoading, onDriverDetailsError);
    };

    return { getDriverDetails, loading, driverDetailsData };
};

export default useDriverDetails;


export interface DriverDetailsDataType {
    address: string,
    assignedFleet: string | null,
    averageRating: number,
    email: string,
    employmentStatus: string,
    employmentType: string,
    firstName: string,
    fleetCategory: string,
    gender: string,
    id: string,
    lastName: string,
    phoneNumber: string,
    profilePicture: string | null,
    reports: any[],
    startDate: string,
    timeAtCompany: number,
    totalNumberOfRatings: number;
    timeSpent?: string;
}
